import { Endpoint } from "@mongez/http";
import type { GenericObject } from "@mongez/reinforcements";

export type ActionResponse = {
  status: number;
  error?: string;
  errors?: {
    message: string;
    key: string;
  }[];
  data: GenericObject;
  isOK: boolean;
};

export function baseAction(path: string) {
  return async (body?: FormData | GenericObject): Promise<ActionResponse> => {
    try {
      const response = await new Endpoint().post(path, body || {});

      return {
        isOK: true,
        data: response.data,
        status: response.status,
      };
    } catch (error: any) {
      return {
        isOK: false,
        status: error?.response?.status,
        error: error?.response?.data?.error || error.message,
        errors: error.response.data.messages || error.response.data.errors,
        data: error?.response?.data,
      };
    }
  };
}

export function action(path: string) {
  return async (body?: FormData | GenericObject): Promise<ActionResponse> => {
    try {
      const response = await new Endpoint().post(path + "/action", body || {});

      return {
        isOK: true,
        data: response.data,
        status: response.status,
      };
    } catch (error: any) {
      return {
        isOK: false,
        status: error?.response?.status,
        error: error?.response?.data?.error || error.message,
        errors: error.response.data.messages || error.response.data.errors,
        data: error?.response?.data,
      };
    }
  };
}
